export default __webpack_public_path__ + "static/media/search.6113d1e8.svg";